import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/app/rootStore';
import { IInitialState } from './sprouts-agent.slice';

const getState = (state: RootState) => state.sproutsAgent;
export const sproutsAgentSelector = createSelector(getState, (state) => state as IInitialState);